export interface ToolMeta {
  route: string;
  label: string;
  desc: string;
  component: () => Promise<unknown>;
}

export const tools: ToolMeta[] = [
  {
    route: '/jwt',
    label: 'JWT',
    desc: 'Decode, verify, редактировать токены',
    component: () => import('@/tools/JwtTool.vue'),
  },
  {
    route: '/json',
    label: 'JSON',
    desc: 'Format, validate, jq-filter',
    component: () => import('@/tools/JsonTool.vue'),
  },
  {
    route: '/base64',
    label: 'Base64',
    desc: 'Encode / decode текст и файлы',
    component: () => import('@/tools/Base64Tool.vue'),
  },
  {
    route: '/url',
    label: 'URL',
    desc: 'Parse, build, encode компоненты',
    component: () => import('@/tools/UrlTool.vue'),
  },
  {
    route: '/hash',
    label: 'Hash',
    desc: 'MD5, SHA, HMAC',
    component: () => import('@/tools/HashTool.vue'),
  },
  {
    route: '/time',
    label: 'Timestamp',
    desc: 'Unix ↔ ISO, timezone',
    component: () => import('@/tools/TimeTool.vue'),
  },
  {
    route: '/uuid',
    label: 'UUID',
    desc: 'Генерация UUID v1/v4/v7',
    component: () => import('@/tools/UuidTool.vue'),
  },
  {
    route: '/json-diff',
    label: 'JSON Diff',
    desc: 'Сравнение JSON-структур',
    component: () => import('@/tools/JsonDiff.vue'),
  },
  {
    route: '/text-diff',
    label: 'Text Diff',
    desc: 'Построчное сравнение текста',
    component: () => import('@/tools/TextDiff.vue'),
  },
  {
    route: '/data',
    label: 'DataForge',
    desc: 'Генерация тестовых данных (РФ)',
    component: () => import('@/tools/DataForge.vue'),
  },
  {
    route: '/cerber',
    label: 'Cerber',
    desc: 'Документация проекта',
    component: () => import('@/tools/CerberPage.vue'),
  },
  {
    route: '/gadb',
    label: 'GADB',
    desc: 'GUI for ADB logcat',
    component: () => import('@/tools/GadbPage.vue'),
  },
  {
    route: '/reports',
    label: 'ReportForge',
    desc: 'Шаблоны отчётов и редактор',
    component: () => import('@/tools/ReportForge.vue'),
  },
  {
    route: '/sse',
    label: 'SSE',
    desc: 'Server-Sent Events клиент',
    component: () => import('@/tools/SseClient.vue'),
  },
  {
    route: '/ws',
    label: 'WebSocket',
    desc: 'WS клиент с автоответами',
    component: () => import('@/tools/WsClient.vue'),
  },
];

export const menuItems = [
  { route: '/', label: 'Главная' },
  ...tools
    .filter((t) => t.route !== '/cerber' && t.route !== '/gadb')
    .map((t) => ({ route: t.route, label: t.label })),
];

export const menuInfoItems = [
  { route: '/cerber', label: 'Cerber' },
  { route: '/gadb', label: 'GADB' },
];

export const menuLegalItems = [
  { route: '/cookies', label: 'Политика cookies' },
  { route: '/privacy', label: 'Персональные данные' },
];
